import React , {useEffect} from "react";
import Navbar from "./components/Navbar";
import Main from "./components/Main";
import Footer from "./components/Footer";
import ScrollToTopGlobal from "./components/ScrollToTopGlobal";
import { PrezentacijaProvider } from "./context/PrezentacijaContext";
import PrezentacijaModal from "./elements/PrezentacijaModal";

function App() {

    useEffect(() => {
        // Check for URL fragment and remove it if present
        if (window.location.hash) {
            window.history.replaceState(null, null, window.location.href.split('#')[0]);
        }
    }, []);

  return (
    <PrezentacijaProvider>
      <ScrollToTopGlobal />
      <Navbar />
      <Main />
      <Footer />
      <PrezentacijaModal />
    </PrezentacijaProvider>
  );
}

export default App;
